import request from '@/utils/request'
export function all(id) {
    return request({
        url: '/vote/'+id,
        method: 'get',

    })
}
export function allLikes(id) {
  return request({
    url: "/vote/like/" + id,
    method: "get"
  });
}
export function getItem(id) {
    return request({
        url: '/vote/item/'+id,
        method: 'get',

    })
}

export function like(id) {
    return request({
        url: '/vote/item/'+id,
        method: 'post',

    })
}
export function likeMulti(data) {
  return request({
    url: "/vote/multi/",
    method: "post",
    data:data
  });
}


// WEBPACK FOOTER //
// ./src/api/vote.js